import { useMutation } from '@tanstack/react-query';
import { createLabOrder } from './labsApi';

/** Query key shared with useIsMutating so a remounted order sheet can see an
 * earlier mount's still-pending submit and keep confirm disabled. */
export const LAB_ORDER_MUTATION_KEY = ['labs', 'order'] as const;

/** Place a lab order. Requester and clinic are resolved server-side. */
export const useCreateLabOrder = () =>
  useMutation({ mutationKey: [...LAB_ORDER_MUTATION_KEY], mutationFn: createLabOrder });
